import sha256 from 'crypto-js/sha256';

export const getHashedString = <T>(request: T) => sha256(JSON.stringify({ ...request })).toString();
